import { ComponentRoute } from '@/classes'

const JcniRoutes = {
  JcniView: new ComponentRoute('/jcni', 'JcniView')
}

export default JcniRoutes